import ContainerCodeNodeView from './ContainerCodeNodeView';
import {fetchWithTimeout} from '../../Common/fetchWithTimeout';
import debounce from 'lodash/debounce';
import {escapeHtml} from '../../Common/escapeHtml';

const handleRenderer = (codeText, dom, name, replaceDomInnerHTML, wrapImage) => {
    const renderLoader = document.getElementById('render-loader');
    renderLoader && renderLoader.classList.add('active');

    fetchWithTimeout('/plantuml', {
        method: 'POST',
        headers: {'Content-Type': 'text/plain'},
        body: codeText
    }).then(response => {
        const contentType = response.headers.get('content-type');

        if (response.ok) {
            response.json().then(fileId => replaceDomInnerHTML(wrapImage(`<img alt="" src="/plantuml/${fileId}"/>`), dom, name));
        } else if (response.status === 400) {
            if (contentType && contentType.includes('application/json')) {
                response.json().then(json => replaceDomInnerHTML(`<pre class="ui error"><code>${json.message ? escapeHtml(json.message) : ''}</code></pre>`, dom, name));
            } else {
                response.text().then(text => replaceDomInnerHTML(`<pre class="ui error"><code>${text ? escapeHtml(text) : ''}</code></pre>`, dom, name));
            }
        } else {
            replaceDomInnerHTML('<pre class="ui error"><code>Unable to load PlantUML diagram renderer, please try again.</code></pre>', dom, name);
        }
        renderLoader && renderLoader.classList.remove('active');
    }).catch(() => {
        replaceDomInnerHTML('<pre class="ui error"><code>Unable to load PlantUML diagram renderer, please try again.</code></pre>', dom, name);
        renderLoader && renderLoader.classList.remove('active');
    });
};

const handleRendererDebounced = debounce((codeText, dom, name, replaceDomInnerHTML, wrapImage) => handleRenderer(codeText, dom, name, replaceDomInnerHTML, wrapImage), 1000);

export default class ContainerPlantumlNodeView extends ContainerCodeNodeView {
    constructor(node, view, getPos) {
        super('plantuml', node, view, getPos);
    }

    renderer(codeText) {
        handleRenderer(codeText, this.viewDom, this.name, this.replaceDomInnerHTML, this.wrapImage);
    }

    rendererDebounced(codeText) {
        handleRendererDebounced(codeText, this.viewDom, this.name, this.replaceDomInnerHTML, this.wrapImage);
    }
}